import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonComponentsModule } from "src/app/common-components";
import { AnlageGroupSelectComponent } from "./anlage-group/anlage-group-select.comnponent";
import { AnlageListComponent } from "./list/anlage-list.component";
import { AnlageApiMonitoringComponentsModule } from "./monitoring/monitoring.module";
import { AnlageSearchComponent } from "./search/anlage-search.component";
import { CstTimelineModule } from "src/app/common-components/cst_Timeline/cst_timeline.module";
import { AnlageApiFacilityInformationPagesGridComponent } from "./facility-information-page/facility-information-pages-grid/facility-information-pages-grid.component";
import { AnlageApiFacilityInformationPagesPdfsCreateComponent } from "./facility-information-page/facility-information-pages-pdfs-create/facility-information-pages-pdfs-create.component";
@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonComponentsModule,
    AnlageApiMonitoringComponentsModule,
    CstTimelineModule
  ],
  declarations: [
    AnlageGroupSelectComponent,
    AnlageListComponent,
    AnlageSearchComponent,
    AnlageApiFacilityInformationPagesGridComponent,
    AnlageApiFacilityInformationPagesPdfsCreateComponent,
  ],
  exports: [
    AnlageApiMonitoringComponentsModule,
    AnlageGroupSelectComponent,
    AnlageListComponent,
    AnlageSearchComponent,
    AnlageApiFacilityInformationPagesGridComponent,
    AnlageApiFacilityInformationPagesPdfsCreateComponent
  ],
})
export class AnlageApiComponentsModule { }
